export const ASSIGN_HARDWARE_LIST_COLS = [
  {
    key: "Vehicle",
    value: "vehicle",
    isFilterEnabled: false,
    filterType: "String",
    isVehicle: true,
    width: "13%",
  },
  {
    key: "Traits",
    value: "weightClass",
    isFilterEnabled: false,
    filterType: "String",
    isTraits: true,
    width: "7%",
  },
  {
    key: "Vehicle Status",
    value: "vehicleStatus",
    isFilterEnabled: false,
    filterType: "String",
    isVehicleStatus: true,
    width: "7%",
  },
  {
    key: "Type",
    value: "type",
    isFilterEnabled: false,
    filterType: "String",
    isType: true,
    width: "7%",
  },
  {
    key: "Subscription Name & ID",
    value: "subscriptionName",
    isFilterEnabled: false,
    filterType: "String",
    isSubName: true,
    width: "24%",
  },
  {
    key: "Tech Ref ID",
    value: "techRefId",
    isFilterEnabled: false,
    filterType: "String",
    isTechRef: true,
    width: "15%",
  },
  {
    key: "Hardware Name",
    value: "hardwareName",
    isFilterEnabled: false,
    filterType: "String",
    isHardName: true,
    width: "16%",
  },
  {
    key: "Hardware ID",
    value: "hardwareId",
    isFilterEnabled: false,
    filterType: "String",
    isHardId: true,
    width: "8%",
  },
];
